
import { Select } from 'antd';
import { useState, useEffect } from 'react';

const TimeFormatSelector = (props) => {

    const [selectedTimeFormat, setSelectedTimeFormat] = useState([]);
    
    const Option = Select.Option;

    useEffect(() => {
        setSelectedTimeFormat("สัปดาห์");
      }, []);

    function onChange(value) {
        setSelectedTimeFormat(value);
    }
    
    props.onChange(selectedTimeFormat);

    return ( 
        <div>
            <Select defaultValue="สัปดาห์" style={{ width: 154, fontSize: '15px'  }} onChange={onChange}>
                {props.streamReady && <Option value="ปี" style={{ color: '#70ad47', fontFamily: 'Helvetica' }}>ปี</Option>}
                {props.streamReady && <Option value="สัปดาห์" style={{ color: '#70ad47', fontFamily: 'Helvetica' }}>สัปดาห์</Option>}
                {props.streamReady && <Option value="เดือน" style={{ color: '#70ad47', fontFamily: 'Helvetica' }}>เดือน</Option>}
            </Select>
        </div>
     );
}
 
export default TimeFormatSelector;